// // Cart popup js SHOP CIRCLE NEW
$(document).ready(function () {
    $(".product-form__cart-submit").click(function (event) {
        $(".product-form__cart-submit").html(`<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-spinner" viewBox="0 0 20 20"><path d="M7.229 1.173a9.25 9.25 0 1 0 11.655 11.412 1.25 1.25 0 1 0-2.4-.698 6.75 6.75 0 1 1-8.506-8.329 1.25 1.25 0 1 0-.75-2.385z" fill="#919EAB"/></svg>`);
        event.preventDefault();
        const params = new URLSearchParams(window.location.search);
        let selectvar = params.get("variant") || $(this).attr("item-id");
        let qnty = $("#Quantity-product-template").val();
        // var requestData = {
        //     items: [{
        //         id: selectvar,
        //         quantity: qnty,
        //     }]
        // };
       let form = document.querySelector('form[action^="/cart/add"]');
        let formdata = new FormData(form);
        $.ajax({
            url: '/cart/add.js',
            method: 'POST',
            dataType: 'json',
            contentType : formdata ? false : 'application/x-www-form-urlencoded; charset=UTF-8',
            processData : formdata ? false : true,
            data: formdata,
            success: function (data) {
            console.log(data);
            if (data && data.id) {
              // Assuming the response data is for a single item
              $(".cart-popup-item img").attr("src", data.image);
              $(".cart-popup-item .cart-popup-item__title").text(data.title);
              $(".cart-popup-item .cart-popup-item__quantity_value").text(data.quantity);
              $(".crt_item_count").text(data.item_count);
              $(".popup_check_out").attr("href", data.url);
              $(".cart-popup-wrapper").addClass("is-transitioning");
              $(".cart-popup-wrapper").removeClass("cart-popup-wrapper--hidden");
              $('#cartItemCount').text(`Cart (${data.item_count} items)`);
              $(".product-form__cart-submit").text("ADD TO CART");

                // include Shop Circle properties
                if (data.properties) {
                    var boldProperties = "";
                    $.each(data.properties, function(key, value) {
                        // Exclude properties that start with "_bold"
                        if (!key.startsWith("_bold")) {
                            if (value) {
                                boldProperties += '<span class="bold_option_title_prop">' + key + ': </span>';
                                var boldStripper = value.split(',');
                                $.each(boldStripper, function(index, item) {
                                    if (item.toLowerCase().indexOf("/uploads/") >= 0) {
                                        boldProperties += '<span class="bold_option_value_title_prop"><a href="' + item + '">uploaded file</a></span>';
                                    } else {
                                        boldProperties += '<span class="bold_option_value_title_prop">' + item + '</span>';
                                    }
                                });
                                boldProperties += '<br/>';
                            }
                        }
                    });
                    // Append Shop Circle properties to the cart popup
                    $('.product-details').append('<div class="line-item_prop">' + boldProperties + '</div>');
                }
                
                    } else {
                        console.error('Invalid or empty response data:', data);
                    }
                },


            error: function (xhr, status, error) {
                // Handle error
                console.error('Error adding product:', error);
            }
        });
    });
    $(".cart-popup__close").click(function (event) {
        $(".cart-popup-wrapper").removeClass("is-transitioning");
        $(".cart-popup-wrapper").addClass("cart-popup-wrapper--hidden");
    });
});

// // Cart popup js OLD
// $(document).ready(function () {
//     $(".product-form__cart-submit").click(function (event) {
//         $(".product-form__cart-submit").html(`<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-spinner" viewBox="0 0 20 20"><path d="M7.229 1.173a9.25 9.25 0 1 0 11.655 11.412 1.25 1.25 0 1 0-2.4-.698 6.75 6.75 0 1 1-8.506-8.329 1.25 1.25 0 1 0-.75-2.385z" fill="#919EAB"/></svg>`);
//         event.preventDefault();
//         const params = new URLSearchParams(window.location.search);
//         let selectvar = params.get("variant") || $(this).attr("item-id");
//         let qnty = $("#Quantity-product-template").val();
//         var requestData = {
//             items: [{
//                 id: selectvar,
//                 quantity: qnty
//             }]
//         };
//         $.ajax({
//             url: '/cart/add.js',
//             method: 'POST',
//             dataType: 'json',
//             contentType: 'application/json',
//             data: JSON.stringify(requestData),
//             success: function (data) {
//                 $.ajax({
//                     type: 'GET',
//                     url: '/cart.js',
//                     dataType: 'json',
//                     success: function (cart) {
//                         $(".cart-popup-item img").attr("src", data.items[0].image);
//                         $(".cart-popup-item .cart-popup-item__title").text(data.items[0].title);
//                         $(".crt_item_count").text(cart.item_count);
//                         $(".popup_check_out").attr("href", `/cart/${data.items[0].id}:${data.items[0].quantity}`)
//                         $(".cart-popup-item .cart-popup-item__quantity_value").text(qnty);
//                         $(".cart-popup-wrapper").addClass("is-transitioning");
//                         $(".cart-popup-wrapper").removeClass("cart-popup-wrapper--hidden");
//                         $('#cartItemCount').text(`Cart (${cart.item_count} items)`);
//                         $(".product-form__cart-submit").text(("ADD TO CART"));
//                     }
//                 });
//             },
//             error: function (xhr, status, error) {
//                 // Handle error
//                 console.error('Error adding product:', error);
//             }
//         });
//     });
//     $(".cart-popup__close").click(function (event) {
//         $(".cart-popup-wrapper").removeClass("is-transitioning");
//         $(".cart-popup-wrapper").addClass("cart-popup-wrapper--hidden");
//     });
// });